'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Monitor, Moon, SunDim } from 'lucide-react';
import { useTheme } from 'next-themes';
import { AnimatedThemeToggler } from '@/shared/components/magicui/animated-theme-toggler';
import { Button } from '@/shared/components/ui/button';
import { ToggleGroup, ToggleGroupItem } from '@/shared/components/ui/toggle-group';
export function ThemeToggler(t0) {
  const $ = _c(29);
  const {
    type: t1,
    className
  } = t0;
  const type = t1 === undefined ? "icon" : t1;
  const {
    theme,
    setTheme
  } = useTheme();
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMounted(true);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== setTheme) {
    t4 = value => {
      setTheme(value);
    };
    $[2] = setTheme;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleThemeChange = t4;
  if (!mounted) {
    return null;
  }
  if (type === "button") {
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Button variant="outline" size="sm" className="hover:bg-primary/10"><SunDim /></Button>;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    return t5;
  } else {
    if (type === "toggle") {
      const t5 = ` ${className}`;
      let t6;
      if ($[5] !== setTheme) {
        t6 = () => setTheme("light");
        $[5] = setTheme;
        $[6] = t6;
      } else {
        t6 = $[6];
      }
      let t7;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <SunDim />;
        $[7] = t7;
      } else {
        t7 = $[7];
      }
      let t8;
      if ($[8] !== t6) {
        t8 = <ToggleGroupItem value="light" onClick={t6} aria-label="Switch to light mode">{t7}</ToggleGroupItem>;
        $[8] = t6;
        $[9] = t8;
      } else {
        t8 = $[9];
      }
      let t9;
      if ($[10] !== setTheme) {
        t9 = () => setTheme("dark");
        $[10] = setTheme;
        $[11] = t9;
      } else {
        t9 = $[11];
      }
      let t10;
      if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = <Moon />;
        $[12] = t10;
      } else {
        t10 = $[12];
      }
      let t11;
      if ($[13] !== t9) {
        t11 = <ToggleGroupItem value="dark" onClick={t9} aria-label="Switch to dark mode">{t10}</ToggleGroupItem>;
        $[13] = t9;
        $[14] = t11;
      } else {
        t11 = $[14];
      }
      let t12;
      if ($[15] !== setTheme) {
        t12 = () => setTheme("system");
        $[15] = setTheme;
        $[16] = t12;
      } else {
        t12 = $[16];
      }
      let t13;
      if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = <Monitor />;
        $[17] = t13;
      } else {
        t13 = $[17];
      }
      let t14;
      if ($[18] !== t12) {
        t14 = <ToggleGroupItem value="system" onClick={t12} aria-label="Switch to system mode">{t13}</ToggleGroupItem>;
        $[18] = t12;
        $[19] = t14;
      } else {
        t14 = $[19];
      }
      let t15;
      if ($[20] !== handleThemeChange || $[21] !== t11 || $[22] !== t14 || $[23] !== t5 || $[24] !== t8 || $[25] !== theme) {
        t15 = <ToggleGroup type="single" className={t5} value={theme} onValueChange={handleThemeChange} variant="outline">{t8}{t11}{t14}</ToggleGroup>;
        $[20] = handleThemeChange;
        $[21] = t11;
        $[22] = t14;
        $[23] = t5;
        $[24] = t8;
        $[25] = theme;
        $[26] = t15;
      } else {
        t15 = $[26];
      }
      return t15;
    }
  }
  let t5;
  if ($[27] !== className) {
    t5 = <AnimatedThemeToggler className={className} />;
    $[27] = className;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
}